var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect } from 'react';
import useUserSesssion from './use-user-session';
import { makeRemoteManageVirtualAccounts } from '@/main/factories/usecases/manage-virtual-accounts/manage-virtual-transactions';
import { RequestQueryBuilder } from '@nestjsx/crud-request';
import { useRecoilState } from 'recoil';
import { studentAccountsState } from '../components';
import { stringCompare } from '../utils/functions';
const service = makeRemoteManageVirtualAccounts(); // Perhaps it would be better to consider making this a hook parameter.
function useStudentAccounts(firstLoad) {
    const [studentWalletState, setStudentWalletState] = useRecoilState(studentAccountsState);
    const { user } = useUserSesssion();
    const checkingAccount = studentWalletState === null || studentWalletState === void 0 ? void 0 : studentWalletState.checkingAccount;
    const creditCardAccount = studentWalletState === null || studentWalletState === void 0 ? void 0 : studentWalletState.creditCardAccount;
    const brokageAccount = studentWalletState === null || studentWalletState === void 0 ? void 0 : studentWalletState.brokageAccount;
    const pockets = studentWalletState === null || studentWalletState === void 0 ? void 0 : studentWalletState.pockets;
    const refeshAccounts = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            if (((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.description) === 'Student') {
                const qb = RequestQueryBuilder.create();
                qb.setFilter({ field: 'userId', operator: '$eq', value: user === null || user === void 0 ? void 0 : user.id });
                const wallets = yield service.find(qb);
                if (wallets) {
                    const checkingAccount = wallets.find(account => { var _a; return ((_a = account === null || account === void 0 ? void 0 : account.accountType) === null || _a === void 0 ? void 0 : _a.description) === 'Checking'; });
                    const creditCardAccount = wallets.find(account => { var _a; return ((_a = account === null || account === void 0 ? void 0 : account.accountType) === null || _a === void 0 ? void 0 : _a.description) === 'Credit Card'; });
                    const brokageAccount = wallets.find(account => { var _a; return stringCompare((_a = account === null || account === void 0 ? void 0 : account.accountType) === null || _a === void 0 ? void 0 : _a.description, 'brokerage'); });
                    const pockets = wallets.filter(account => { var _a; return ((_a = account === null || account === void 0 ? void 0 : account.accountType) === null || _a === void 0 ? void 0 : _a.description) === 'Pocket'; });
                    setStudentWalletState(prev => (Object.assign(Object.assign({}, prev), { accounts: wallets, checkingAccount,
                        creditCardAccount,
                        pockets,
                        brokageAccount, balance: (checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.balance) || '0' })));
                }
            }
            else {
                console.error(`No Student in user session, userRole[${(_b = user === null || user === void 0 ? void 0 : user.role) === null || _b === void 0 ? void 0 : _b.description}]`);
            }
        }
        catch (error) {
            console.error(error);
        }
    });
    const getAccounts = () => {
        return (studentWalletState === null || studentWalletState === void 0 ? void 0 : studentWalletState.accounts) || [];
    };
    useEffect(() => {
        if (firstLoad)
            refeshAccounts();
    }, []);
    return { checkingAccount, creditCardAccount, brokageAccount, pockets, refeshAccounts, getAccounts };
}
export default useStudentAccounts;
